import { Component, Input } from "@angular/core";
import { FocusedFormComponent } from "../../component/wrapper/focused-form.component";
import { FormsModule } from "@angular/forms";
import { AuthUser } from "../../../../globalTypes/auth.types";
import { OnInit } from "@angular/core";
import { filter } from "rxjs/operators";
import { authUserFeature } from "../../store/authUser.store";
import { Store } from "@ngrx/store";
import { lastValueFrom } from "rxjs";
import { take } from "rxjs/operators";
import { FormInputPhoneNumberComponent } from "../../component/forms/form-input-phone-number.component";
import { updateMyUser } from "@dataconnect/account";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LimiterDirective } from "../../directive/limiter";

@Component({
  selector: 'msh-manage-profile-details',
  imports: [FocusedFormComponent, LimiterDirective, FormsModule, FormInputPhoneNumberComponent],
  template: `
    
  <msh-focused-form
    [hideSubmitButton]="hideSubmitButton || !!creationStage" 
    [isLoading]="isLoading" 
    (onSubmit)="onSubmit($event)" 
    [disabled]="!newDisplayName" 
    [cta]="cta"
  >
      <div class="text-lg font-bold mb-4">Profile Details</div>
        <div class="ml-2 mb-2">
          Email: {{ authUser?.email}}
        </div>
        <div>
          <input
            type="text"
            placeholder="Full Name"
            [(ngModel)]="newDisplayName"
            [limiter]="150"
            name="displayName"
            required
          />
        </div>
        <msh-form-input-phone-number
          [placeholder]="'Mobile Phone Number'"
          [phoneNumber]="newMobile"
          (onImmediatePhoneNumberChange)="newMobile = $event"
          (onPhoneNumberChange)="newMobile = $event"
          required
        >
        </msh-form-input-phone-number>
        <div class="text-sm null relative -top-6">(only used to communicate the status of an order)</div>
      
  </msh-focused-form>
  `
})
export class ManageProfileDetailsPageComponent implements OnInit {

  hideSubmitButton = false;
  isLoading = false;
  creationStage: 'creatingUser' | 'updatingProfile' | undefined;
  creatingStages: ('creatingUser' | 'updatingProfile')[] = ['creatingUser', 'updatingProfile'];
  cta = 'Update';
  newDisplayName?: string = '';
  newMobile?: string = '';
  authUser?: AuthUser | null = null;

  constructor(
    private store: Store,
    private snackBar: MatSnackBar
  ) {}

  async ngOnInit() {
    this.authUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(filter(u => !!u), take(1)));
    console.log('authUser', this.authUser);
    this.newDisplayName = this.authUser?.displayName;
    this.newMobile = this.authUser?.mobile;
  }

  async onSubmit(ev: Event){
    this.isLoading = true;
    try {
      const updated = await updateMyUser({
        displayName: this.newDisplayName,
        mobile: this.newMobile
      });
      this.snackBar.open('Profile updated successfully', 'Close', { duration: 3000 });
    } catch (error) {
      this.snackBar.open('Failed to update profile', 'Close', { duration: 8000 });
      console.error('Failed to update profile', error);
    }
    this.isLoading = false;
  }
}